import styled from 'styled-components';

export const StyledLinks = styled.div`
    padding: 100px 0;

    h2 {
        text-align: center;
    }
`